import React, { createContext, useContext, useMemo } from 'react';

const SecurityOperationContext = createContext({
  status: null,
  readState: 'inactive',
  readError: null,
  sessionScopeToken: '',
  publicationState: null,
  retryClientPublication: null,
  pendingReveal: null,
  acknowledgeReveal: null,
});

export function SecurityOperationProvider({
  children,
  status = null,
  readState = 'inactive',
  readError = null,
  sessionScopeToken = '',
  publicationState = null,
  retryClientPublication = null,
  pendingReveal = null,
  acknowledgeReveal = null,
}) {
  const value = useMemo(() => ({
    status,
    readState,
    readError,
    sessionScopeToken,
    publicationState,
    retryClientPublication,
    pendingReveal,
    acknowledgeReveal,
  }), [
    acknowledgeReveal,
    publicationState,
    retryClientPublication,
    pendingReveal,
    readError,
    readState,
    sessionScopeToken,
    status,
  ]);
  return (
    <SecurityOperationContext.Provider value={value}>
      {children}
    </SecurityOperationContext.Provider>
  );
}

export const useSecurityOperationContext = () => useContext(SecurityOperationContext);
